export default "__VITE_ASSET__cc3a2f13__"